// extracted by mini-css-extract-plugin
export default {"comment":"social-section-link-post-LinkPostSection__comment--2R0m0"};